<template>
    <div class="total-paid shown">
        <div class="inner shown">
            {{ translations.bill.paid }}
            <span class="value">{{ toMoneyWithSign(totalPaid, true) }}</span>
            <span class="excl">{{ translations.bill.exclTip }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { translations } from "@/shared/localization/translations";
    import { toMoneyWithSign } from "@/shared/utils/format";

    // define properties
    defineProps<{
        totalPaid: number;
    }>();
</script>

<style lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";
    @use "./../../../assets/styles/scss/shared/_variables.scss";

    .total-paid {
        position: relative;
        background-color: colors.$fontColor;
        transition: height 0.4s variables.$easeOutExpo;
        height: 0;

        > .inner {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            font-size: 12px;
            color: #fff;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 27px;
            text-align: center;
            opacity: 0;
            transform: translate(0, -10px);
            transition:
                transform 0.6s variables.$easeOutExpo,
                opacity 0.6s variables.$easeOutExpo;
            transition-delay: 0.1s;

            > .value {
                font-weight: 700;
            }

            > .excl {
                padding-left: 4px;
                font-size: 9px;
            }

            &.shown {
                opacity: 1;
                transform: translate(0, 0);
            }

            &.gone {
                opacity: 0;
                transform: translate(0, 10px);
            }
        }

        &.shown {
            height: 27px;
        }
    }
</style>
